import { createContext, useContext, useMemo } from 'react'
// graphql
import gql from 'graphql-tag'
import { useQuery, useSubscription } from '@apollo/react-hooks'
import { withRouter } from 'react-router'

const ME = gql`
query GetMe {
  me {
    id
    email
    username
    name
    meta
    admin
    devices {
      id
      name
      serial
      enabled
      model
      meta
      online
      po_number
      purchased_at
      created_at
      description
      last_connection {
        id
        created_at
        destroyed_at
      }
    }
  }
}
`
const GraphQLDatas = createContext()

export const useGraphQLDatas = () => {
  const context = useContext(GraphQLDatas)
  if (context === undefined) {
    throw new Error(`useGraphQLDatas must be called within UserContextProvider`)
  }
  return context
}

const UserContextProvider = ({ children }) => {
  const { loading, error, data } = useQuery(ME)

  let value = useMemo(() => ({
    loading,
    error,
    data
  }), [data])

  return (
    <GraphQLDatas.Provider value={value}>
      {children}
    </GraphQLDatas.Provider>
  )
}

export default withRouter(UserContextProvider)
